import React, { memo } from "react";
import ReactDOM from "react-dom";
// @ts-expect-error - this will be resolved at build time
import { Box } from "@xsolla/xui-primitives";
import { useResolvedTheme, TOAST_LAYER } from "@xsolla/xui-core";
import { Toast } from "./Toast";
import type { ToastGroupProps } from "./types";

const TOAST_GROUP_CONFIG = {
  containerPadding: 12,
  groupGap: 8,
};

export const ToastGroup = memo(
  ({
    toasts,
    position = "top",
    align = "center",
    maxWidth,
    onDismiss,
    testID,
    themeMode,
    themeProductContext,
  }: ToastGroupProps) => {
    useResolvedTheme({ themeMode, themeProductContext });
    const config = TOAST_GROUP_CONFIG;

    if (toasts.length === 0 || typeof document === "undefined") {
      return null;
    }

    const positionStyles =
      position === "top"
        ? { top: config.containerPadding, bottom: undefined }
        : { top: undefined, bottom: config.containerPadding };

    const alignMap = {
      left: "flex-start",
      center: "center",
      right: "flex-end",
    } as const;

    return ReactDOM.createPortal(
      <Box
        testID={testID}
        position="fixed"
        left={0}
        right={0}
        zIndex={TOAST_LAYER}
        alignItems={alignMap[align]}
        paddingHorizontal={config.containerPadding}
        pointerEvents="box-none"
        {...positionStyles}
      >
        <Box
          width="100%"
          maxWidth={maxWidth}
          gap={config.groupGap}
          flexDirection="column"
        >
          {toasts.map((toast) => (
            <Toast
              key={toast.id}
              id={toast.id}
              type={toast.type}
              title={toast.title}
              description={toast.description}
              descriptionLines={toast.descriptionLines}
              icon={toast.icon}
              action={toast.action}
              showCloseButton={toast.showCloseButton}
              progress={toast.progress}
              duration={toast.duration}
              onClose={() => onDismiss(toast.id)}
            />
          ))}
        </Box>
      </Box>,
      document.body
    );
  }
);

ToastGroup.displayName = "ToastGroup";
